import { render, staticRenderFns } from "./knowDatil.vue?vue&type=template&id=028d709d&scoped=true"
import script from "./knowDatil.vue?vue&type=script&lang=js"
export * from "./knowDatil.vue?vue&type=script&lang=js"
import style0 from "./knowDatil.vue?vue&type=style&index=0&id=028d709d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d709d",
  null
  
)

export default component.exports